import React, { createElement, type ComponentType, type ReactNode } from 'react';
type ProvidersProps = {
    children: ReactNode;
    providers: ComponentType<{ children: ReactNode }>[];
};
const Providers: React.FC<ProvidersProps> = ({ children, providers }: ProvidersProps) =>
    providers.reduceRight((acc, Provider) => {
        return createElement(Provider, null, acc);
    }, children);
export default Providers;
